var map = {
	"./assets/TDR/1_Introduction_To_SEO": [
		2435,
		1,
		435
	],
	"./assets/TDR/2_History_Of_SEO": [
		4374,
		1,
		374
	],
	"./assets/TDR/3_SEO_Fundamentals": [
		2996,
		1,
		996
	],
	"./assets/TDR/4_Technical_SEO": [
		6110,
		1,
		110
	],
	"./assets/TDR/5_Content_Optimisation": [
		6787,
		1,
		787
	],
	"./assets/TDR/6_Local_SEO": [
		2442,
		1,
		442
	],
	"./assets/TDR/7_SEO_Analytics_And_Metrics": [
		6848,
		1,
		848
	],
	"./assets/TDR/8_Emerging_Trends": [
		5571,
		1,
		571
	],
	"./assets/TDR/9_Ethical_And_Legal_Considerations": [
		9978,
		1,
		978
	],
	"./assets/TDR/posts": [
		9280,
		3
	],
	"./assets/TDR/posts.json": [
		9280,
		3
	],
	"./assets/about/mockup.webp": [
		7939,
		1
	],
	"./assets/blog/BTCPay Server's Seamless Integration with React Apps": [
		3259,
		1,
		259
	],
	"./assets/blog/Mastering Texture Mapping with Pygame A Comprehensive Guide": [
		6273,
		1,
		273
	],
	"./assets/blog/The Ultimate Guide to Upgrading Your Steam Deck": [
		2026,
		1,
		26
	],
	"./assets/blog/Top Games for Oculus Quest 3 Must Play Titles": [
		8734,
		1,
		734
	],
	"./assets/blog/Transforming Patient Care With AI-Powered Monitoring": [
		270,
		1,
		270
	],
	"./assets/blog/Understanding and Resolving iPhone 15 Overheating Issues": [
		14,
		1,
		14
	],
	"./assets/blog/posts": [
		5051,
		3
	],
	"./assets/blog/posts.json": [
		5051,
		3
	],
	"./assets/contact/LinkedInBackground.svg": [
		5673,
		1,
		673
	],
	"./assets/contact/LinkedInNothingIcon.svg": [
		5576,
		1,
		576
	],
	"./assets/contact/PFP.webp": [
		595,
		1,
		595
	],
	"./assets/hero/bg1.webp": [
		2021,
		1
	],
	"./assets/hero/bg2.webp": [
		7746,
		1
	],
	"./assets/logo.webp": [
		8936,
		1
	],
	"./assets/me.jpg": [
		8451,
		1
	],
	"./assets/popup/popup.jpg": [
		2994,
		1
	],
	"./assets/portfolio": [
		2668,
		9
	],
	"./assets/portfolio/": [
		2668,
		9
	],
	"./assets/portfolio/Bitcoin.webp": [
		8095,
		1
	],
	"./assets/portfolio/GPTArticles.webp": [
		3160,
		1
	],
	"./assets/portfolio/Logitech.webp": [
		5997,
		1
	],
	"./assets/portfolio/SpotifyConcept.webp": [
		8895,
		1
	],
	"./assets/portfolio/index": [
		2668,
		9
	],
	"./assets/portfolio/index.js": [
		2668,
		9
	],
	"./assets/testimonials": [
		100,
		9,
		100
	],
	"./assets/testimonials/": [
		100,
		9,
		100
	],
	"./assets/testimonials/Juan.webp": [
		9987,
		1
	],
	"./assets/testimonials/Vithanco.webp": [
		8034,
		1
	],
	"./assets/testimonials/Walter.webp": [
		7223,
		1
	],
	"./assets/testimonials/index": [
		100,
		9,
		100
	],
	"./assets/testimonials/index.js": [
		100,
		9,
		100
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3383;
module.exports = webpackAsyncContext;